"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

var _echarts = _interopRequireDefault(require("@/lib/echarts"));

var _resize = _interopRequireDefault(require("../mixins/resize"));

//
//
//
//
var animationDuration = 6000;
var _default = {
  mixins: [_resize.default],
  props: {
    className: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "300px"
    },
    placeholder: {
      type: String,
      default: ""
    },
    labels: {
      default: []
    },
    values: {
      default: []
    },
    isPercent: {
      type: Boolean,
      default: false
    },
    chartTitle: {
      type: String,
      required: false
    },
    chartSubtitle: {
      type: String,
      required: false
    },
    typeSuccess: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      chart: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.initChart();
    });
  },
  computed: {
    locale: function locale() {
      return this.$i18n.locale;
    },
    chartColor: function chartColor() {
      return this.typeSuccess ? '#2d527c' : '#b3404a';
    }
  },
  watch: {
    locale: function locale(_locale) {
      this.initChart();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }

    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart: function initChart() {
      this.chart = _echarts.default.init(this.$el, "macarons");
      this.chart.setOption({
        title: {
          text: this.chartTitle,
          subtext: this.chartSubtitle,
          show: true,
          top: 0,
          left: 0,
          z: 1,
          zLevel: 1,
          textStyle: {
            color: '#000'
          },
          subtextStyle: {
            color: '#000'
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'

          },
          formatter: this.isPercent ? '{b} <br /> {a} : {c}%' : '{b} <br /> {a} : {c}'
        },
        grid: {
          top: 60,
          left: 160,
          bottom: 20 // containLabel: true

        },
        yAxis: [{
          type: "category",
          data: this.labels,
          inverse: true,
          // axisTick: {
          //   alignWithLabel: true
          // },
          z: 100,
          axisLabel: {
            show: true,
            // interval: 0, //强制所有标签显示
            align: 'left',
            // verticalAlign: 'middle',
            margin: 150,
            //标签向右移动 如果yAxis 跟 xAxis换了,这个margin应该调为0才能看见标签显示
            width: 10,
            overflow: 'breakAll',
            textStyle: {
              color: "#000",
              lineHeight: 20
            },
            formatter: function formatter(params) {
              if (params.length > 20) return params.substring(0, 20) + '...';else return params;
            }
          }
        }],
        xAxis: {
          type: "value",
          min: 0,
          max: this.isPercent ? 100 : null,
          data: this.values,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            formatter: this.isPercent ? '{value}%' : '{value}'
          }
        },
        series: [{
          name: this.placeholder,
          type: "bar",
          stack: "vistors",
          barWidth: "60%",
          data: this.values,
          animationDuration: 1400,
          animationEasing: "cubicInOut",
          itemStyle: {
            color: this.chartColor
          }
        }]
      });
    }
  }
};
exports.default = _default;